import { PhonePrefixOption } from "./components/Step1Container";

export const PHONE_PREFIX_OPTS: PhonePrefixOption[] = [
  {
    value: "+84",
    text: "+84",
  },
];

export const FORMSPREE_ENQUIRY_ACTION = `https://formspree.io/${process.env
  .REACT_APP_ENQUIRY_ADDRESS}`;



// WEBPACK FOOTER //
// ./src/routes/Step1/constants.ts